export const allScoring = ["most-popular"] as const;

export type Scoring = (typeof allScoring)[number];
